import React, { useState, useEffect } from 'react';
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'us-east-1_VHDa4Ftzs',
  ClientId: '1bscmli1vv0cd0hfipcfanht6r'
};

const userPool = new CognitoUserPool(poolData);

function PopupLogin({ onAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Login form submitted');

    const authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password
    });

    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    });

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        const idToken = result.getIdToken().getJwtToken();
        
        const username = cognitoUser.getUsername();
        localStorage.setItem('username', username);
        
        localStorage.setItem('idToken', idToken);
        onAuthenticated(true, idToken);
        
        // Close the popup
        const popup = document.querySelector('.popup-login');
        if (popup) {
          closePopupLogin(popup);
        }
      },
      onFailure: (err) => {
        console.error(err);
      }
    });
  };

  // Add this function to your component
  const closePopupLogin = (popup) => {
    popup.classList.remove("js-popup-open");
    popup.querySelector("form").reset();
    unblockScrollBody();
    console.log("Popup closed: .popup-login");
  };

  // Add this function to unblock scroll
  const unblockScrollBody = () => {
    const html = document.querySelector('html');
    html.classList.remove("js-no-scroll");
  };

  return (
    <section className="popup popup-login">
      <div className="popup-login__body popup__body">
        <button className="popup__close" type="button"></button>
        <h3 className="popup__title">Login with</h3>
        <div className="popup-login__social-list">
          {/* ... social login buttons ... */}
        </div>
        <form className="popup-login__form login-form" onSubmit={handleSubmit}>
          <label className="form-group">
            <span>Email/Username</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username" // Changed from autocomplete to autoComplete
            />
          </label>
          <label className="form-group form-group--password">
            <span>Password<a className="form-group__forgot" href="" title="forgot?">forgot?</a></span>
            <button className="form-group-eye-toggle" type="button"></button>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password" // Changed from autocomplete to autoComplete
            />
          </label>
          <label className="remember-me">
            <input type="checkbox" value="remember me" />
            <span>remember me</span>
          </label>
          <button type="submit" className="button button--primary popup__form-submit login-form__submit">Login</button>
        </form>
        <div className="login-form__register-now">
          Not a member?
          <button className="js-popup-register-open" type="button">Register now</button>
        </div>
      </div>
    </section>
  );
}

export default PopupLogin;
